<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Purchasing</span></h5>
              <h3 class="my-3">
                <span>
                  {{ getTotalPurchasing | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Retur</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>
                  {{ getTotalReturn | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Total Payment</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ getTotalPayment | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Total Outstanding</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ getTotalOutstanding | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Delivery Cost</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ getTotalDeliveryCost | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Persediaan</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ totalJournalPersediaan | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Hutang</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ totalJournalHutang | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Journal</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ totalJournalPersediaan + totalJournalDelivery | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
    </div>
    <div class="row">
      <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Pembelian</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-sm btn-soft-primary dropdown-toggle" data-toggle="dropdown" id="dropDownFilter">Action<span class="caret"></span></button>
                    <ul class="dropdown-menu p-2" aria-labelledby="dropDownFilter">
                      <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="approveAll">Approve</a></li>
                      <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="deleteAll">Void</a></li>
                      <li><a href="javascript:void(0)" class="small" tabIndex="-1" data-toggle="modal" data-target="#modalPurchasingListSchedule" data-backdrop="static" data-keyboard="false" >Jadwal</a></li>
                      <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="setJournal">Set Journal</a></li>
                      <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="clearPurchasing">Clear Purchasing</a></li>
                    </ul>
                    <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addProduct">
                      <i class="fa fa-plus" aria-hidden="true"></i> New
                    </button>
                    <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshPurchasing">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                  </div>
                  <div class="button-group">
                    <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown" id="filter">
                      <i class="fa fa-filter" aria-hidden="true"></i>
                        Filter
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu p-2" aria-labelledby="filter">
                      <span>Company:</span>
                      <div class="dropdown-divider"></div>
                      <li v-for="ct in companyList" :key="ct.id">
                        <a href="#" class="small" tabIndex="-1">
                          <input type="checkbox" :value="ct.company_no" v-model="filterCompany"/>&nbsp; {{ ct.name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="button-group">
                    <button class="btn btn-warning btn-sm dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                    <div class="dropdown-menu" aria-labelledby="print">
                      <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                      <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                    </div>
                  </div>
                  <div class="button-group">
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ filterData.length }}</b>
                    </span>
                    <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshPurchasing"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="27" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer">
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td @click="editPurchasing(u.id)">
                          <span class="badge badge-primary" v-if="u.status === 'order'">{{ u.status }}</span>
                          <span class="badge badge-danger" v-else-if="u.status === 'void'">{{ u.status }}</span>
                          <span class="badge badge-success" v-else-if="u.status === 'approve'">{{ u.status }}</span>
                          <span class="badge badge-warning" v-else>{{ u.status }}</span>
                        </td>
                        <td>
                          <!-- <button v-if="u.total_return <= 0" type="button" class="btn btn-sm btn-soft-outline-primary" @click="returPurchasing(u.id)">Retur</button> -->
                          <!-- <button v-else type="button" class="btn btn-sm btn-hard-primary" @click="returPurchasing(u.id)">Retur</button> -->
                        </td>
                        <td @click="editPurchasing(u.id)">{{ u.qty_total }}</td>
                        <td @click="editPurchasing(u.id)">
                          <span v-for="o in u.order" :key="o.sp_no">{{ o.sp_no }}, </span>
                        </td>
                        <td @click="editPurchasing(u.id)">{{ u.type }}</td>
                        <td @click="editPurchasing(u.id)"><b>{{ u.purchasing_no }}</b></td>
                        <td @click="editPurchasing(u.id)">{{ u.ext_no }}</td>
                        <td @click="editPurchasing(u.id)">{{ u.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td @click="editPurchasing(u.id)">{{ u.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td @click="editPurchasing(u.id)">{{ u.schedule_payment_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td @click="editPurchasing(u.id)">{{ u.faktur_no }}</td>
                        <td @click="editPurchasing(u.id)">{{ u.faktur_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td @click="editPurchasing(u.id)">{{ u.vendor }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.subtotal | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.discount | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.tax | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.delivery_cost | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.total | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.total_payment | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.total_return | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.outstanding | currency }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">{{ u.details_count }}</td>
                        <td @click="editPurchasing(u.id)" class="text-right">
                          <span v-if="u.inventory_count !== u.details_count" class="badge badge-danger">{{ u.inventory_count }}</span>
                          <span v-else class="badge badge-success">{{ u.inventory_count }}</span>
                        </td>
                        <td @click="editPurchasing(u.id)" class="text-right">
                          <span v-if="u.total !== u.total_persediaan" class="badge badge-danger">{{ u.total_persediaan | currency }}</span>
                          <span v-else>{{ u.total_persediaan | currency }}</span>
                        </td>
                        <td @click="editPurchasing(u.id)" class="text-right">
                          <span>{{ u.total_hutang | currency }}</span>
                        </td>
                        <td @click="editPurchasing(u.id)" class="text-right">
                          <span>{{ u.total_delivery | currency }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                </table>
              </div>
            </div>
          </div>
      </div>
      <PurchasingListModal @getDate="processScheduleDate" />
      <PurchasingRequestModal />
      <!-- <pre>{{ dataRaw }}</pre> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { inventoryUrl, productUrl, purchasingUrl, purchasing2Url, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import PurchasingListModal from '@/components/purchasing/PurchasingListModal.vue'
import PurchasingRequestModal from '@/components/purchasing/PurchasingRequestModal.vue'

export default {
  name: 'PurchasingList',
  components: {
    Loading,
    DatePicker,
    PurchasingListModal,
    PurchasingRequestModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), parseFloat(date.getDate()) - 7)
    // var lastDay = new Date()
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      loadingSales: true,
      filterCompany: ['C0001', 'C0002'],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: '#',
        prop: '',
        align: 'text-left'
      }, {
        name: 'Qty',
        prop: 'qty_total',
        align: 'text-left'
      }, {
        name: 'Order',
        prop: 'order',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Purchasing No',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Invoice No.',
        prop: 'ext_no',
        align: 'text-left'
      }, {
        name: 'Tgl.',
        prop: 'purchasing_date',
        align: 'text-left'
      }, {
        name: 'Tgl. Tempo',
        prop: 'purchasing_due_date',
        align: 'text-left'
      }, {
        name: 'Jadwal Pembayaran',
        prop: 'schedule_payment_date',
        align: 'text-left'
      }, {
        name: 'Faktur',
        prop: 'faktur_no',
        align: 'text-left'
      }, {
        name: 'Tgl. Faktur',
        prop: 'faktur_date',
        align: 'text-left'
      }, {
        name: 'Vendor',
        prop: 'vendor',
        align: 'text-left'
      }, {
        name: 'Subtotal',
        prop: 'subtotal',
        align: 'text-right'
      }, {
        name: 'Discount',
        prop: 'discount',
        align: 'text-right'
      }, {
        name: 'Tax',
        prop: 'tax',
        align: 'text-right'
      }, {
        name: 'Delivery Cost',
        prop: 'delivery_cost',
        align: 'text-right'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }, {
        name: 'Payment',
        prop: 'total_payment',
        align: 'text-right'
      }, {
        name: 'Retur',
        prop: 'total_return',
        align: 'text-right'
      }, {
        name: 'Outstanding',
        prop: 'outstanding',
        align: 'text-right'
      }, {
        name: 'Detail Count',
        prop: 'details_count',
        align: 'text-right'
      }, {
        name: 'Inventory Count',
        prop: 'inventory_count',
        align: 'text-right'
      }, {
        name: 'Total Journal Persediaan',
        prop: 'total_persediaan',
        align: 'text-right'
      }, {
        name: 'Total Journal Hutang',
        prop: 'total_hutang',
        align: 'text-right'
      }, {
        name: 'Total Journal Delivery',
        prop: 'total_delivery',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshPurchasing()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    totalJournalPersediaan () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_persediaan)
      }
      return sum
    },
    totalJournalHutang () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_hutang)
      }
      return sum
    },
    totalJournalDelivery () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_delivery)
      }
      return sum
    },
    getTotalDeliveryCost () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].delivery_cost)
      }
      return sum
    },
    getTotalReturn () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_return)
      }
      return sum
    },
    getTotalPayment () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_payment)
      }
      return sum
    },
    getTotalOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    getTotalPurchasing () {
      var num = 0
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      for (let i = 0; i < array.length; i++) {
        num += parseFloat(array[i].total)
      }
      return num
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async clearPurchasing () {
      this.$Progress.start()
      this.loader.isLoading = true
      await axios.get(inventoryUrl + '/clear-purchasing', { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    async setJournal () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        await axios.get(purchasingUrl + '/journal/' + array[i], { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error.response)
            this.$Progress.finish()
            this.loader.isLoading = false
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success set journal', 'success')
    },
    returPurchasing (id) {
      axios.get(purchasingUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('returnPurchasing', response.data.data)
        })
        .catch(response => {
          this.$swal(
            'Error!!!',
            response,
            'error'
          )
        })
    },
    async processScheduleDate (value) {
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i],
          schedule_payment_date: value
        }
        await axios.post(purchasingUrl + '/schedule-payment', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            console.log(error.response.data.data.id)
            return false
          })
      }
      await this.$swal('Success', 'Success create schedule payment', 'success')
    },
    async deleteAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      var detail = []
      for (let i = 0; i < array.length; i++) {
        await axios.delete(purchasingUrl + '/' + array[i], { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
            if (response.data.data.details) {
              var arr = response.data.data.details
              for (let i = 0; i < arr.length; i++) {
                var obj = {
                  product_no: arr[i].product_no,
                  date: response.data.data.purchasing_date,
                  company_no: response.data.data.company_no
                }
                detail.push(obj)
              }
            }
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
      }
      for (let a = 0; a < detail.length; a++) {
        var data = {
          date: detail[a].date,
          product_no: detail[a].product_no,
          type: 'all',
          company_no: detail[a].company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('Success Sync COGS ALL ' + detail[a].product_no)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }

      if (resp.error === true) {
        await this.$swal('Error', resp.message, 'error')
        await this.$Progress.finish()
        this.loader.isLoading = false
      } else {
        await this.$swal('Success', resp.message, 'success')
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
      await this.refreshPurchasing()
      this.selected = []
    },
    async approveAll () {
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i]
        }
        await axios.post(purchasingUrl + '/approve', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        await axios.get(purchasingUrl + '/' + array[i], { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            var arr = response.data.data.details
            for (let i = 0; i < arr.length; i++) {
              var data = {
                date: response.data.data.purchasing_date,
                product_no: arr[i].product_no,
                type: 'all',
                company_no: response.data.data.company_no
              }
              axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                .then(response => {
                  console.log('Success Sync COGS ALL ' + arr[i].product_no)
                })
                .catch(error => {
                  console.log(error.response)
                  this.$swal('Error', error.response.data.message, 'error')
                  throw error
                })
            }
          })
        await this.setJournalAll(array[i])
      }
      if (resp.error) {
        this.$swal('Error', resp.message, 'error')
      } else {
        this.$swal('Success', resp.message, 'success')
        this.selected = []
        await this.refreshPurchasing()
      }
    },
    async setJournalAll (id) {
      await axios.get(purchasingUrl + '/journal/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editPurchasing (id) {
      this.loader.isLoading = true
      axios.get(purchasingUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editPurchasing', response.data.data)
          this.loader.isLoading = false
        })
        .catch(error => {
          this.loader.isLoading = false
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    addProduct () {
      this.$emit('newPurchasing', true)
      // var payload = {
      //   date: this.date
      // }
      // this.$store.dispatch('getProductWithTotal', payload)
    },
    async refreshPurchasing () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = purchasingUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          this.loader.isLoading = false
          if (error === 'Error: Network Error') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          } else if (error.response.data.message === 'This action is unauthorized.') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          }
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        format: type,
        data: this.dataRaw,
        begin: begin,
        end: end
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(purchasing2Url + '/print', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>
